module.exports = __webpack_public_path__ + "src/assets/img/share/tips/extroversion/6d98ee24909f5a380f23d143f4a76d98.png";